import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoutingPathsService } from './shared/routing-paths.service';
import { PublicLayoutComponent } from '@app/public/public-layout.component';
import { UserSelectionComponent } from './user-selection/user-selection.component';
import { LoadingGuard } from '@app/core/loading.guard';

export const routes: Routes = [
  {
    path: 'user-selection',
    component: UserSelectionComponent,
    loadChildren: () => import('./user-selection/user-selection.module').then((m) => m.UserSelectionModule),
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        canActivate: [LoadingGuard],
        path: 'login',
        loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
      },
    ],
    data: { reuse: true },
  },
  {
    path: 'logout',
    children: [
      {
        path: '',
        loadChildren: () => import('./logout/logout.module').then((m) => m.LogoutModule),
      },
    ],
    data: { reuse: true },
  },
  {
    path: 'maintenance',
    children: [
      {
        path: 'programat',
        loadChildren: () => import('./maintenance/maintenance.module').then((m) => m.MaintenanceModule),
      },
      {
        path: 'neprogramat',
        loadChildren: () => import('./maintenance/maintenance.module').then((m) => m.MaintenanceModule),
      },
    ],
    data: { reuse: true },
  },
  // Fallback when no prior route is matched
  {
    path: RoutingPathsService.paths.pageNotFound,
    loadChildren: () => import('./error/error.module').then((m) => m.ErrorModule),
  },
  {
    path: '**',
    redirectTo: RoutingPathsService.paths.pageNotFound,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes /*, { enableTracing: true }*/, {})],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
